import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import "../assets/css/About.css";

import heroFallback from "../assets/images/about-hero.jpg";

/* Feature icons */
import docPad from "../assets/icons/doc-pad-check.png";
import searchIcon from "../assets/icons/search.png";
import verifiedIcon from "../assets/icons/verified.png";
import docsIcon from "../assets/icons/docs.png";

import ashish from "../assets/images/ashish.jpg";
import shubham from "../assets/images/shubham.jpeg";
import ashok from "../assets/images/chaubeysr.jpeg";
import paras from "../assets/images/Pars.jpeg";
import anurag from "../assets/images/Anurag.jpeg";
import matovu from "../assets/images/matovu.jpeg";

/* Offerings images */
import blueCar from "../assets/images/blue-car.png";
import docsImg from "../assets/images/docs.png";
import uaeFlag from "../assets/images/uae-flag.png";
import steeringOnly from "../assets/images/only-steering.png";
import steering from "../assets/images/steering.png";
import backCars from "../assets/images/back-cars.png";
import valuesBg from "../assets/images/values-bg.jpg";
import roadmapBg from "../assets/images/roadmap-bg.jpg";

const About = () => {
  const { t } = useTranslation();

  return (
    <main className="about">
      {/* HERO */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url(${heroFallback})` }}
      >
        <div className="overlay">
          <div className="container new-container">
            <div className="container-in-pd">
              <h1 className="w-7">{t("about.hero.fallbackTitle")}</h1>

              <p className="hero-text">
                {t("about.hero.fallbackSubtitle")}
              </p>

              <p className="hero-points">
                {t("about.hero.points.1")}<br />
                {t("about.hero.points.2")}<br />
                {t("about.hero.points.3")}
              </p>

              {/* HERO CTA → CONTACT */}
              <Link to="/contact" className="btn c-btn">
                {t("about.hero.cta")}
              </Link>

              {/* HERO BOXES */}
              <div className="row g-4 hero-boxes">
                {[
                  { icon: docPad, text: t("about.heroCards.1") },
                  { icon: docsIcon, text: t("about.heroCards.2") },
                  { icon: verifiedIcon, text: t("about.heroCards.3") },
                  { icon: searchIcon, text: t("about.heroCards.4") }
                ].map((item, i) => (
                  <div className="col-md-3" key={i}>
                    <div className="hero-card">
                      <p>{item.text}</p>
                      <img src={item.icon} alt="" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FOUNDERS */}
      <section className="founders">
        <div className="container">
          <h2 className="text-center">
            <Trans i18nKey="about.founders.title" />
          </h2>

          <p className="text-center founders-intro">
            {t("about.founders.intro")}
          </p>

          <h2 className="text-center mt-5">
            {t("about.story.title")}
          </h2>

          <p className="text-center founders-intro">
            {t("about.story.text")}
          </p>

          <div className="row mt-5 about-founders">
            <div className="col-md-4 ex-padding mtl-c">
              <div className="team-img-section text-center">
                <img src={ashok} alt="Ashok Chaubey" className="team-img" />
              </div>

              <h4 className="w-7">
                {t("about.team.ashok.name")}
              </h4>

              <p className="designation">
                <Trans
                  i18nKey="about.team.ashok.designation"
                  components={[
                    <span className="fi fi-in" key="in" />,
                    <span className="fi fi-ae" key="ae" />
                  ]}
                />
              </p>

              <p className="team-bio">{<Trans i18nKey="about.team.ashok.bio"/>}</p>
            </div>

            <div className="col-md-4 ex-padding mtl-c mmt-5">
              <div className="team-img-section text-center">
                <img src={ashish} alt="Ashish Mishra" className="team-img" />
              </div>

              <h4 className="w-7">
                {t("about.team.ashish.name")}
              </h4>

              <p className="designation">
                <Trans
                  i18nKey="about.team.ashish.designation"
                  components={[
                    <span className="fi fi-in" key="in" />,
                    <span className="fi fi-ae" key="ae" />
                  ]}
                />
              </p>

              <p className="team-bio">{<Trans i18nKey="about.team.ashish.bio"/>}</p>
            </div>

            <div className="col-md-4 ex-padding mtl-c mmt-5">
              <div className="team-img-section text-center">
                <img src={shubham} alt="Shubham Chaubey" className="team-img" />
              </div>

              <h4 className="w-7">
                {t("about.team.shubham.name")}
              </h4>

              <p className="designation">
                <Trans
                  i18nKey="about.team.shubham.designation"
                  components={[
                    <span className="fi fi-in" key="in" />,
                    <span className="fi fi-ae" key="ae" />
                  ]}
                />
              </p>

              <p className="team-bio">{<Trans i18nKey="about.team.shubham.bio"/>}</p>
            </div>

            <div className="col-md-4 ex-padding mtl-c mmt-5">
              <div className="team-img-section text-center">
                <img src={paras} alt="Paras Jagtap" className="team-img" />
              </div>

              <h4 className="w-7">
                {t("about.team.paras.name")}
              </h4>

              <p className="designation">
                <Trans i18nKey="about.team.paras.designation" />
              </p>

              <p className="team-bio">{<Trans i18nKey="about.team.paras.bio"/>}</p>
            </div>

            <div className="col-md-4 ex-padding mtl-c mmt-5">
              <div className="team-img-section text-center">
                <img src={anurag} alt="Anurag" className="team-img" />
              </div>

              <h4 className="w-7">
                {t("about.team.anurag.name")}
              </h4>

              <p className="designation">
                <Trans
                  i18nKey="about.team.anurag.designation"
                  components={[<span className="fi fi-in" key="in" />]}
                />
              </p>

              <p className="team-bio">{<Trans i18nKey="about.team.anurag.bio"/>}</p>
            </div>


            <div className="col-md-4 ex-padding mtl-c mmt-5">
              <div className="team-img-section text-center">
                <img src={matovu} alt="Matovu Abbasi" className="team-img" />
              </div>

              <h4 className="w-7">{t("about.team.matovu.name")}</h4>

              <p className="designation">
                <Trans i18nKey="about.team.matovu.designation" />
              </p>

              <p className="team-bio">
                {<Trans i18nKey="about.team.matovu.bio" />}
              </p>
            </div>
          </div>

        </div>
      </section>

      {/* OFFERINGS */}
      <section className="offerings" id="what-we-offer">
        <div className="container new-container">
          <h2 className="text-center">
            <div className="f-w-7">{t("about.offerings.title")}</div>
            <br />
          </h2>
          <p className="offer-subtitle">{t("about.offerings.subtitle")}</p>

          <div className="row g-4 mt-4">
            {t("about.offerings.items", { returnObjects: true }).map(
              (item, i) => (
                <div className="col-md-4" key={i}>
                  <div className="ex-padding">
                    <div className="offer-card text-center">
                      <img
                        src={[
                          blueCar,
                          docsImg,
                          uaeFlag,
                          steeringOnly,
                          steering,
                          backCars
                        ][i]}
                        alt={item.title}
                        className="offer-img"
                      />
                      <h4 className="mb-4">{item.title}</h4>
                      <p>{item.text}</p>
                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section
        className="values"
        style={{ backgroundImage: `url(${valuesBg})` }}
      >
        <div className="values-overlay">
          <div className="container text-center">
            <h2>{<Trans i18nKey="about.values.title" />}</h2>
            <p className="values-intro">
              {t("about.values.subtitle")}
            </p>

            <div className="row g-4 mt-5 justify-content-center values-row">
              {t("about.values.items", { returnObjects: true }).map(
                (item, i) => (
                  <div className="col-12 col-sm-6 col-lg value-col" key={i}>
                    <div className="value-card">
                      <h5>{item.title}</h5>
                      <p>{item.text}</p>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        </div>
      </section>

      {/* ROADMAP */}
      <section
        className="roadmap"
        style={{ backgroundImage: `url(${roadmapBg})` }}
      >
        <div className="roadmap-overlay">
          <div className="container text-center">
            <h2>{t("about.roadmap.title")}</h2>
            <p className="roadmap-intro mb-4">
              {t("about.roadmap.subtitle")}
            </p>

            <div className="row g-4 mt-4">
              {t("about.roadmap.items", { returnObjects: true }).map((item, i) => (
                <div className="col-md-4" key={i}>
                  <div className="roadmap-card">
                    <h3>{item.highlight}</h3>

                    <h5>
                      <Trans components={{ br: <br /> }}>
                        {item.title}
                      </Trans>
                    </h5>

                    <div className="roadmap-white">
                      <span>{item.year}</span>
                      <p>
                        <Trans components={{ br: <br /> }}>
                          {item.text}
                        </Trans>
                      </p>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* ROADMAP CTA → CONTACT */}
            <Link to="/contact" className="btn c-btn mt-5">
              {t("about.roadmap.cta")}
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;
